export default __webpack_public_path__ + "static/media/icon_css.02d225c7.png";